import * as React from 'react';
import config from '../../config';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import FlightIcon from '@mui/icons-material/FlightLand';
import ListIcon from '@mui/icons-material/MapOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import PaymentIcon from '@mui/icons-material/Payment';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
import { GetSystemSettings } from '../../REST/utilities';
import { RequestLostCard, ContactUs, WorkOrderRequest, WrapperBox } from "./widgets"

const background = config.REACT_APP_BACKGROUND_IMG
const background_size = config.REACT_APP_BACKGROUND_SIZE
const logo = config.REACT_APP_LOGO_IMG
const name = config.REACT_APP_NAME
const SIGN_IN_URL = `${config.REACT_APP_COGNITO_URL}/login?response_type=code&client_id=${config.REACT_APP_COGNITO_CLIENT_ID}&redirect_uri=${config.REACT_APP_COGNITO_SIGNIN}&scope=${config.REACT_APP_COGNITO_SCOPE}`

const tiers = [
    {
        title: 'Transient Pass',
        buttonText: 'Submit',
        icon: <FlightIcon />,
        link: 'tiedown/create'
    },
    {
        title: 'Property Listings',
        buttonText: 'View Listings',
        icon: <ListIcon />,
        link: 'listings'
    },
    {
        title: 'Contact Us',
        buttonText: 'Contact Us',
        icon: <PhoneIcon />,
        widget: ContactUs
    },
    {
        title: 'Lost Cards',
        buttonText: 'Contact Us',
        icon: <CreditCardOffIcon />,
        widget: RequestLostCard
    },
    {
        title: "Add Workorders",
        buttonText: 'Add New',
        icon: <HomeRepairServiceIcon />,
        widget: WorkOrderRequest
    },
    {
        title: 'Pay an Invoice',
        buttonText: 'Pay Now',
        icon: <PaymentIcon />,
        link: 'pay'
    }
];


export default function App() {
    const [config, setConfig] = React.useState(null)

    const navigate = useNavigate()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    React.useEffect(() => {
        GetSystemSettings().then((result) => {
            const setting = result.data.find((x) => { return x.name == "appconfig" })
            if (setting) setConfig(setting.jsonvalue)

        })
    }, [])
    if (config == null) return <></>
    return (
        <Box className="landing-wrapper" sx={{
            backgroundImage: config.REACT_APP_BACKGROUND_IMG ? `url(${config.REACT_APP_BACKGROUND_IMG})` : `url(${background})`,
            backgroundSize: background_size,
            backgroundRepeat: "round"
        }}>
            {/* Header with gradient background */}
            

            <Container className="landing-title-section">
                {/* Main Title */}
                <Typography 
                    variant="landing-title" 
                    component="h1" 
                    align="center"
                    sx={{ 
                        color: config.logocolor || 'white',
                        mb: 2
                    }}
                >
                    {config.REACT_APP_NAME || 'All-in-One Solution Leasing Parking And Assets'}
                </Typography>
                
                {/* Logo Image */}
                {(config.REACT_APP_LOGO_IMG || logo) && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <img 
                            src={config.REACT_APP_LOGO_IMG || logo}
                            key={config.REACT_APP_LOGO_IMG || logo} 
                            alt="Logo" 
                            style={{ 
                                maxHeight: config.logoHeight || '100px',
                                height: 'auto',
                                width: 'auto',
                                maxWidth: '100%',
                                objectFit: 'contain'
                            }} 
                        />
                    </Box>
                )}
                
                {/* Powered By Section */}
                <Typography variant="landing-caption" align="center" component="p" sx={{ mb: 0.5 }}>
                    POWERED BY
                </Typography>
                <Box className="landing-link-wrapper">
                    <Typography 
                        variant="landing-revjet"
                        component="a"
                        rel="noopener noreferrer" 
                        target="_blank"
                        href="https://www.delasoft.com/"
                    >
                        Delasoft
                    </Typography>
                </Box>
            </Container>
            <Container maxWidth="md" component="main">
                {config.landinglinks &&
                    isMobile ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                            {tiers.map((tier) => {
                                const row = (
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            px: 1.5,
                                            py: 1.25,
                                            borderRadius: 2,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            backgroundColor: 'rgba(255,255,255,0.95)',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: '#ede7f6',
                                                    flexShrink: 0,
                                                    '& svg': {
                                                        fontSize: '1.25rem',
                                                        color: '#673ab7'
                                                    }
                                                }}
                                            >
                                                {tier.icon}
                                            </Box>
                                            <Box sx={{ minWidth: 0 }}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700 }} noWrap>
                                                    {tier.title}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary" noWrap title={tier.buttonText}>
                                                    {tier.buttonText}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <ChevronRightIcon sx={{ color: 'primary.main', flexShrink: 0 }} />
                                    </Paper>
                                )

                                if (tier.widget) {
                                    return (
                                        <WrapperBox key={tier.title} Widget={tier.widget}>
                                            {row}
                                        </WrapperBox>
                                    )
                                }

                                return (
                                    <Box
                                        key={tier.title}
                                        onClick={() => {
                                            if (tier.external)
                                                document.location.href = tier.link
                                            else
                                                navigate(tier.link ? tier.link : '')
                                        }}
                                        title={tier.title}
                                    >
                                        {row}
                                    </Box>
                                )
                            })}
                        </Box>
                    ) : (
                        <Grid container spacing={{ xs: 1.25, sm: 2 }}>
                            {tiers.map((tier) => (
                                <Grid
                                    item
                                    key={tier.title}
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={2}
                                >
                                    <Card
                                        variant="landing-card"
                                        sx={{
                                            minHeight: { xs: 170, sm: 190 },
                                        }}
                                    >
                                        <CardHeader
                                            variant="landing-card-header"
                                            title={tier.title}
                                            titleTypographyProps={{
                                                title: tier.title,
                                                noWrap: true,
                                            }}
                                            sx={{
                                                minHeight: { xs: 48, sm: 56 },
                                                py: { xs: 0.75, sm: 1.5 },
                                                px: { xs: 1.5, sm: 2 },
                                            }}
                                        />
                                        <CardContent
                                            variant="landing-card-content"
                                            sx={{
                                                py: { xs: 0.75, sm: 1 },
                                                px: { xs: 1.25, sm: 2 },
                                                '& .icon-circle': {
                                                    width: { xs: 42, sm: 48 },
                                                    height: { xs: 42, sm: 48 },
                                                    '& svg': {
                                                        fontSize: { xs: '1.15rem', sm: '1.4rem' },
                                                    },
                                                },
                                            }}
                                        >
                                            <Box className="icon-circle">
                                                {tier.icon}
                                            </Box>
                                        </CardContent>
                                        <CardActions
                                            variant="landing-card-actions"
                                            sx={{
                                                p: { xs: 1, sm: 1.5 },
                                            }}
                                        >
                                            <>
                                                {
                                                    tier.widget && <tier.widget />
                                                }
                                                {
                                                    !tier.widget &&
                                                    <Button
                                                        variant="landing-action"
                                                        onClick={() => {
                                                            if (tier.external)
                                                                document.location.href = tier.link
                                                            else
                                                                navigate(tier.link ? tier.link : '')
                                                        }}
                                                        fullWidth
                                                        endIcon={<ChevronRightIcon />}
                                                    >
                                                        {tier.buttonText}
                                                    </Button>
                                                }
                                            </>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )
                }
            </Container>
        </Box>
    );
}
